import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import {
  BaseLeadPage,
  CarleadHIWWhyChooseWkdaFaq,
  CarleadLicensePlateNLCustomerCounterBuyCar,
} from '@wkda/marketing-components';

function CarleadCreation() {
  return (
    <BaseLeadPage
      form={CarleadLicensePlateNLCustomerCounterBuyCar}
      content={CarleadHIWWhyChooseWkdaFaq}
      headlineDesktop="carleadCreation.form.title"
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
